export const VERSION = {
  major: 0,
  minor: 0,
  patch: 0,
  build: process.env.REACT_APP_BUILD_NUMBER || '0'
};

export const getVersionString = () => {
  return `${VERSION.major}.${VERSION.minor}.${VERSION.patch}.${VERSION.build}`;
};
